import { AdmService } from 'src/app/shared/services/adm.service';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { BuscadorCotizacion } from 'src/app/shared/models/buscadorCotizacion';
import { ClasePorEstado, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { Compania } from 'src/app/shared/models/compania';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { DatePipe, DecimalPipe } from '@angular/common'
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, startWith, switchMap, tap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { PedidoVentaCabecera } from 'src/app/shared/models/pedidoVentaCabecera';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { PVService } from 'src/app/shared/services/pv.service';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SelectorDivisionesComponent } from 'src/app/shared/components/selector-divisiones/selector-divisiones.component';
import { SelectorEstadoPedidosComponent } from 'src/app/shared/components/selector-estado-pedidos/selector-estado-pedidos.component';
import { SelectorRegionesComponent } from 'src/app/shared/components/selector-regiones/selector-regiones.component';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { ZonaVendedor } from 'src/app/shared/models/zonaVendedor';
import { CotizacionCabecera } from 'src/app/shared/models/cotizacionCabecera';
import { PedidoCotizado } from 'src/app/shared/models/pedidoCotizado';
import { CotizacionesService } from 'src/app/shared/services/cotizaciones.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Division } from 'src/app/shared/models/division';
import { Region } from 'src/app/shared/models/region';
import { Estado } from 'src/app/shared/models/estado';
import { Cuenta } from 'src/app/shared/models/cuenta';


@Component({
  selector: 'app-cotizaciones-buscador',
  templateUrl: './cotizaciones-buscador.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})



export class CotizacionesBuscadorComponent {

  @ViewChild(SelectorDivisionesComponent, { static: true }) selectorDivision: SelectorDivisionesComponent;
  @ViewChild(SelectorRegionesComponent, { static: true }) selectorRegion: SelectorRegionesComponent;
  @ViewChild(SelectorEstadoPedidosComponent, { static: true }) selectorEstadoPedido: SelectorEstadoPedidosComponent;
  @ViewChild('matSort') matSort: MatSort;
  @ViewChild('matPaginator') matPaginator: MatPaginator;
  displayedColumns = ['acciones', 'nroPedido', 'fechaCreacion', 'nombreCliente', 'estado', 'fechaEstado', 'terminoPago', 'idZonaVendedor', 'total', 'totalLocal', 'expand'];
  dataSource = new MatTableDataSource<CotizacionCabecera>();

  dataSource2 = new MatTableDataSource<PedidoCotizado>([]); // Reemplaza 'TuTipoDeDatos' por el tipo de datos de tus filas

  filteredOptions: any;
  formControlAutocomplete = new FormControl('');
  hint: string = ""
  isLoading = false;
  minLengthTerm = 2;
  userName = this.loggedService.logged.userName;
  //#region autocomplete Cliente

  clientesEncontrados: any;
  clienteSeleccionado: Cuenta;
  fcAutocompleteCliente = new FormControl('');
  hintC: string = ""
  loadingFcAutocompleteCliente = false;
  minLengthTermCliente = 2;

  //#endregion
  buscador: BuscadorCotizacion;
  autocompletableZonaVendedor: boolean = true;
  rolesConRegion: ItemParametro[] = [];
  selectRegiones: boolean = true;
  zonaVendedorSeleccionada: ZonaVendedor = null;
  companias: Compania[] = [];
  salesOrgs: SalesOrg[] = [];
  motivosRetencion: ItemParametro[] = []
  alta: boolean = false;
  fDesde: Date | null;
  fHasta: Date | null;
  divisionSeleccionada: Division = null
  estadoSeleccionado: Estado = null
  regionSeleccionada: Region = null

  columnsToDisplay = ['name', 'weight', 'symbol', 'position'];
  columnsToDisplayWithExpand = [...this.displayedColumns, 'expand'];
  expandedElement: PedidoCotizado | null;

  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private productosService: ProductosService,
    private snackBarService: SnackbarService,
    private parametrosService: ParametrosService,
    private cotizacionesService: CotizacionesService,
    private admService: AdmService,
    private tablasService: TablasService) {


  }


  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string,
    Mas: string,
    CambiarEstado: string,
    LimpiarVendedor: string,
    Copiar: string
  }

  public Etiquetas: {

    Acciones: string
    Buscar: string
    Compania: string
    Estado: string
    FechaCreacion: string
    FechaDesde: string
    FechaEstado: string,
    FechaHasta: string
    IdZonaVendedor: string
    MotivoRetencion: string
    NombreCliente: string,
    NombreDistribuidor: string;
    NroCliente: string
    NroOrdenSAP: string
    NroPedido: string;
    Path: string
    SalesOrg: string
    SinRegistros: string
    TerminoPago: string,
    Titulo: string
    TotalUSD: string,
    TotalLocal: string,
    BuscarCliente: string,
    Cliente: string,
    BuscarVendedor: string,
    NroCotizacion: string

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.matPaginator;
    this.dataSource.sort = this.matSort;
    this.dataSource.sort.disableClear = true;
  }

  ngOnInit() {
    const buscadorCotData = sessionStorage.getItem('buscadorCotizacion');
    if (buscadorCotData) {
      // Recuperar el objeto y mapear las fechas a tipo Date
      const buscadorCot: BuscadorCotizacion = Object.assign(new BuscadorCotizacion(), JSON.parse(buscadorCotData));

      // Convertir campos de fecha
      buscadorCot.fDesde = new Date(buscadorCot.fDesde);
      buscadorCot.fHasta = new Date(buscadorCot.fHasta);


      this.buscador = buscadorCot;
      if (this.buscador.idZonaVendedor != '-1') {
        this.zonaVendedorSeleccionada = new ZonaVendedor();
        this.zonaVendedorSeleccionada.displayValue = this.buscador.idZonaVendedor + ' - ' + this.buscador.zonaVendedor
      }
      if (this.buscador.nroCliente != '-1') {
        this.clienteSeleccionado = new Cuenta();
        this.clienteSeleccionado.displayValue = this.buscador.nroCliente + ' - ' + this.buscador.nombreCliente

      }
      this.buscador.nroPedido = Number(buscadorCot.nroPedido)

      if (this.buscador.idDivision != "-1") {
        this.divisionSeleccionada = new Division()
        this.divisionSeleccionada.id = this.buscador.idDivision;
      }
      if (this.buscador.idRegion != "-1") {
        this.regionSeleccionada = new Region()
        this.regionSeleccionada.id = this.buscador.idRegion;
      }
      if (this.buscador.idEstado != -1) {
        this.estadoSeleccionado = new Estado()
        this.estadoSeleccionado.id = this.buscador.idEstado.toString();
      }
      this.buscador.idMotivoRetencion = buscadorCot.idMotivoRetencion

    } else {
      this.buscador = new BuscadorCotizacion();
    }

    this.dataSource.data = [];
    //this.dataSource2.data=[];

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
      Mas: this.configService.tooltips.Mas,
      LimpiarVendedor: this.configService.tooltips.LimpiarVendedor,
      CambiarEstado: this.configService.tooltips.CambiarEstado,
      Ver: this.configService.tooltips.Ver,
      Copiar: this.configService.tooltips.Copiar
    }

    this.Etiquetas = {

      Acciones: this.configService.etiquetas.Acciones,
      Buscar: this.configService.etiquetas.Buscar,
      Compania: this.configService.etiquetas.Compania,
      Estado: this.configService.etiquetas.Estado,
      FechaCreacion: this.configService.etiquetas.FechaCreacion,
      FechaDesde: this.configService.etiquetas.FechaDesde,
      FechaEstado: this.configService.etiquetas.FechaEstado,
      FechaHasta: this.configService.etiquetas.FechaHasta,
      IdZonaVendedor: this.configService.etiquetas.IdZonaVendedor,
      MotivoRetencion: this.configService.etiquetas.MotivoRetencion,
      NombreCliente: this.configService.etiquetas.NombreCliente,
      NombreDistribuidor: this.configService.etiquetas.NombreDistribuidor,
      NroCliente: this.configService.etiquetas.NroCliente,
      NroOrdenSAP: this.configService.etiquetas.NroOrdenSAP,
      NroPedido: this.configService.etiquetas.NroPedido,
      Path: this.configService.etiquetas.Cotizaciones.Buscador.Path,
      SalesOrg: this.configService.etiquetas.SalesOrg,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      TerminoPago: this.configService.etiquetas.TerminoPago,
      Titulo: this.configService.etiquetas.Cotizaciones.Buscador.Titulo,
      TotalUSD: this.configService.etiquetas.TotalUSD,
      TotalLocal: this.configService.etiquetas.TotalLocal,
      BuscarCliente: this.configService.etiquetas.BuscarCliente,
      Cliente: this.configService.etiquetas.Cliente,
      BuscarVendedor: this.configService.etiquetas.BuscarVendedor,
      NroCotizacion: this.configService.etiquetas.NroCotizacion,

    }
    //this.buscador = new BuscadorCotizacion();
    this.formControlAutocomplete = new FormControl();
    this.formControlAutocomplete.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTerm
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.filteredOptions = [];
          this.isLoading = true;
        }),
        switchMap(value => this.admService.cZonasVendedoresAutocompleteSearch(this.loggedService.logged.idPais, this.buscador.idCompania, this.buscador.idSalesOrg, value)
          .pipe(
            finalize(() => {
              this.isLoading = false
            }),
          )
        )
      )
      .subscribe((data: ZonaVendedor[]) => {
        this.filteredOptions = data;

      });
      this.fcAutocompleteCliente.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermCliente
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.clientesEncontrados = [];
          this.loadingFcAutocompleteCliente = true;
        }),
        switchMap(value => this.admService.cClientesPedidoAutocompleteSearch(this.loggedService.logged.idPais, this.buscador.idCompania, this.buscador.idSalesOrg, this.buscador.idDivision, this.loggedService.logged.idZonaVendedor, this.loggedService.logged.idRegion, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteCliente = false
            }),
          )
        )
      )
      .subscribe((data: Cuenta[]) => {
        this.clientesEncontrados = data;

      });
    this.buscador.idPais = this.loggedService.logged.idPais;
    if (this.buscador.fDesde == null) {
      this.buscador.fHasta = new Date();
      const fechaDesdeDate = new Date();
      fechaDesdeDate.setMonth(fechaDesdeDate.getMonth() - 4);
      this.buscador.fDesde = fechaDesdeDate;
    }
    forkJoin([
      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.parametrosService.cItemsParametros(10), //Motivos retencion
      this.parametrosService.cItemParametroXDescripcionItem(25, "COTIZACION"), //Cambiar descripcionItem segun tipo de pedido
      this.parametrosService.cItemsParametros(60) //Roles Alta

    ]).subscribe((data: [Compania[], SalesOrg[], ItemParametro[], ItemParametro, ItemParametro[]]) => {

      if (data[0].length) {

        this.companias = data[0];
        this.buscador.idCompania = data[0][0].id;
      }

      if (data[1].length) {

        this.salesOrgs = data[1];
        this.buscador.idSalesOrg = data[1][0].id;
      }

      if (data[2].length) {

        this.motivosRetencion = data[2];

      }
      if (data[3] != null) {
        if (data[3].idItem.length) {
          this.buscador.idTipoOrden = data[3].idItem;
        }
      }
      if (data[4] != null) {
        if (data[4].length) {
          if (this.loggedService.validToken()) {
            data[4].forEach(rol => {
              if (this.loggedService.logged.rol == rol.idItem && !this.alta) {
                this.alta = true;
              }
            });
          }
        }
      }

      this.selectorEstadoPedido.cEstados(this.loggedService.logged.idPais, "12");

      if (!this.loggedService.logged.idRegion.length) {
        // this.selectorRegion.cRegiones(this.loggedService.logged.idPais);
        this.selectRegiones = true;
      }
      else {
        this.buscador.idRegion = this.loggedService.logged.idRegion;
        this.selectRegiones = false;
      }

      if (!this.loggedService.logged.idZonaVendedor.length) {
        if (this.isInRole('VENDEDOR')) {
          this.buscador.idZonaVendedor = null;
          this.buscador.zonaVendedor = null;
          this.autocompletableZonaVendedor = false;
        }
        else {
          this.autocompletableZonaVendedor = true;
        }

      }
      else {
        this.buscador.idZonaVendedor = this.loggedService.logged.idZonaVendedor;
        this.buscador.zonaVendedor = this.loggedService.logged.zonaVendedor;
        this.autocompletableZonaVendedor = false;
      }

      if (this.loggedService.logged.nroClienteDistribuidor != null && this.loggedService.logged.nroClienteDistribuidor !== '') {
        this.buscador.nroClienteDistribuidor = this.loggedService.logged.nroClienteDistribuidor; // solo los distribuidores vienen con nroClienteDistribuidor

      } else {
        this.buscador.nroClienteDistribuidor = '-1'
      }


      let timer = setTimeout(() => {
        this.buscar(0);
      }, 250);


    });
  }

  buscar(idTipoMensaje: number) {
    sessionStorage.setItem('buscadorCotizacion', JSON.stringify(this.buscador));
    if (!this.buscador.nroPedido) {
      this.buscador.nroPedido = 0;
    }
    this.buscador.fDesde.setHours(0, 0, 0);
    this.buscador.fHasta.setHours(0, 0, 0);
    this.cotizacionesService
      .cCotizaciones(this.buscador)
      .subscribe((data: CotizacionCabecera[]) => {
        this.dataSource.data = [];
        if (data.length) {

          this.dataSource.data = data;
          /* this.dataSource.data.forEach(d => {
            d.PedidosCotizadosString = ""; // Initialize PedidosCotizadosString as an empty string

            if (d.pedidoCotizados != null) {
                d.pedidoCotizados.forEach(p => {
                  // Concatenate desired fields with appropriate separators
                  d.PedidosCotizadosString += "  Nro. de Pedido: "+p.nroPedido+',  Tipo de Orden: ' + p.tipoOrden +", Estado: "+p.estado+",  Fecha Entrega: "+p.fechaEntrega+", Total: "+p.total+",  Total CLP: "+p.totalLocal+"\n";
              });
            }
          }); */

          //? d.pedidoCotizados.map(p => {p.nroPedido,p.tipoOrden,p.estado,p.fechaEntrega,p.total,p.totalLocal}).join(' ') 
          this.cAcciones();
          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
              break;

          }
        }

      })

  }

  isDetailRow = (index: number, row: any) => row.idEstado === 4;


  cAcciones() {
    this.dataSource.data.forEach(c => {
      if (c.idEstado == 1 && (c.usuarioRedSolicitante == this.userName || this.isInRole('ADMVENTAS') || this.isInRole('ADM LOCAL') || this.isInRole('ADM'))) {
        c.editar = true;
      }
      if (!c.editar) {
        if (c.idEstado != 1 || c.usuarioRedSolicitante != this.userName) {
          c.ver = true;
        }
      }
      if (c.idEstado == 4) {
        c.mas = true;
      }
    });
  }


  recibirDivisionEmitida(division: any) {
    if (typeof division != 'undefined') {
      this.divisionSeleccionada = division;
      if (division != this.buscador.idDivision) {
        this.buscador.idDivision = division.toString();
      }
    }
  }

  recibirRegionEmitida(region: any) {
    if (typeof region != 'undefined') {
      this.regionSeleccionada = region;
      if (region != this.buscador.idRegion) {
        this.buscador.idRegion = region.toString();
      }
    }
  }

  recibirEstadoEmitido(estado: any) {
    if (typeof estado != 'undefined') {
      this.estadoSeleccionado = estado;
      if (estado != this.buscador.idEstado) {
        this.buscador.idEstado = estado;
      }
    }
  }

  getOptionText(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  seleccionarVendedor(zv: any) {
    this.zonaVendedorSeleccionada = zv;
    this.buscador.idZonaVendedor = this.zonaVendedorSeleccionada.id;
    this.buscador.zonaVendedor = this.zonaVendedorSeleccionada.descripcion;
  }

  handleEmptyInputVendedor(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTerm) {
      this.limpiarVendedor(false);
    }
  }
  limpiarVendedor(resetFormControl: boolean) {
    this.filteredOptions = [];
    this.zonaVendedorSeleccionada = null;
    this.buscador.idZonaVendedor = "-1";
    if (resetFormControl) {
      this.formControlAutocomplete.setValue('');

    }

  }
  getOptionTextCliente(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  seleccionarCliente(c: any) {
    this.clienteSeleccionado = c;
    this.buscador.nroCliente = this.clienteSeleccionado.nroCliente;
    this.buscador.nombreCliente = this.clienteSeleccionado.nombre;
  }

  handleEmptyInputCliente(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTerm) {
      this.limpiarCliente(false);
    }
  }
  limpiarCliente(resetFormControl: boolean) {
    this.clientesEncontrados = [];
    this.clienteSeleccionado = null;
    this.buscador.nroCliente = "-1";
    if (resetFormControl) {
      this.fcAutocompleteCliente.setValue('');

    }

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  clasePorEstado(id: string) {
    let clase = ClasePorEstado("12", id);
    return clase;
  }

  clasePorEstadoPedidos(idTipoOrden: string, id: string) {
    let clase = ClasePorEstado(idTipoOrden, id);
    return clase;
  }

  cotizacion(codigo: number, idTipo: number) {

    this.router.navigate([this.configService.etiquetas.Cotizaciones.Cotizacion.Path], {
      queryParams: {
        codigo: codigo, //Si es distinto de cero es edicion/ver,
        idTipo: idTipo //1 = nuevo, 2 = edición, 3: ver
      }
    });
  }

  IrAlPedido(codigo: number, idTipo: number, idTipoOrder: string) {
    const rutaActual = this.router.url; // obtén la ruta actual
    switch (idTipoOrder) {
      case "1":
        this.router.navigate([this.configService.etiquetas.PedidosVenta.PV.Path], {
          queryParams: {
            codigo: codigo, //Si es distinto de cero es edicion/ver,
            idTipo: idTipo //1 = nuevo, 2 = edición, 3: ver //Le voy a pasar 3 siempre, ya que estan en estado Pendiente de Envio            
          },
          state: { rutaAnterior: rutaActual }
        });
        break;
      case "11":
        this.router.navigate([this.configService.etiquetas.PedidosVentaAnticipada.PVA.Path], {
          queryParams: {
            codigo: codigo, //Si es distinto de cero es edicion/ver,
            idTipo: idTipo //1 = nuevo, 2 = edición, 3: ver
          },
          state: { rutaAnterior: rutaActual }
        });
        break;
      case "5":
        this.router.navigate([this.configService.etiquetas.PedidosEspecialesPlanta.PEP.Path], {
          queryParams: {
            codigo: codigo, //Si es distinto de cero es edicion/ver,
            idTipo: idTipo //1 = nuevo, 2 = edición, 3: ver
          },
          state: { rutaAnterior: rutaActual }
        });
        break;
      case "10":
        this.router.navigate([this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.PEPA.Path], {
          queryParams: {
            codigo: codigo, //Si es distinto de cero es edicion/ver,
            idTipo: idTipo //1 = nuevo, 2 = edición, 3: ver
          },
          state: { rutaAnterior: rutaActual }

        });
        break;
    }
  }
copiarPedido(codigo: number){
  this.cotizacionesService
  .copiarCotizacion(codigo)
  .subscribe(() => {

    this.buscar(0)
  });

}

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }




}




